export const columnHeader = [
	{
	  key: 'name', name: 'Name', type: 'text', system: false, filter: true
	},
	{
	  key: 'state', name: 'State', type: 'text', system: false, filter: true
	},
	{
	  key: 'provider', name: 'Provider', type: 'text', system: false, filter: true
	},
	{
	  key: 'server', name: 'Server', type: 'text', system: false, filter: true
	},
	{
	  key: 'ip', name: 'IP', type: 'text', system: false, filter: true
	},
	{
	  key: 'type', name: 'Type', type: 'text', system: false, filter: true
	},
	{
	  key: 'root', name: 'Root', type: 'text', system: false, filter: true
	},
	{
	  key: 'cores', name: 'Cores', type: 'number', system: false, filter: true
	},
    {
  	  key: 'subnets', name: 'Subnets', type: 'text', system: true, filter: true
    },
	{
  	  key: 'users', name: 'Users', type: 'text', system: true, filter: false
    },
	{
	  key: 'actions', name: '', type: 'actions', system: true, filter: false
	}
  ];

  export const types = [
	{
		value: 'Premium Private',
		label: 'Premium Private'
	},
	{
		value: 'Premium',
		label: 'Premium'
	}
  ];


export const state = [
	{
		value: 'online',
		label: 'online'
	},
	{
		value: 'offline',
		label: 'offline'
	},
	{
		value: 'down',
		label: 'down'
	}
];